import dayjs from 'dayjs';
import { isFalsy } from 'utility-types';

export const convertMilliSecondsToMiutesAnsSeconds = (
  milliseconds: number
): {
  minutes: string;
  seconds: string;
} => {
  const minutes = String(Math.floor((milliseconds / (1000 * 60)) % 60)).padStart(2, '0');
  const seconds = String(Math.floor((milliseconds / 1000) % 60)).padStart(2, '0');
  return {
    minutes,
    seconds
  };
};

export const convertUnixToDateTime = (unixString: string, format?: string): string => {
  if (unixString === '') {
    return unixString;
  }

  dayjs.locale('ko');
  const date = dayjs(unixString);

  return date.format(format ?? 'YYYY-MM-DD');
};

export const getTimeOffset = (time: string, standard?: Date): string => {
  standard = standard ?? new Date();
  const _time = new Date(time);

  const diffInMs = standard.getTime() - _time.getTime();
  const diffInSeconds = Math.floor(diffInMs / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);
  const diffInDays = Math.floor(diffInHours / 24);

  if (diffInMinutes < 60) {
    return `${diffInMinutes}분 전`;
  }

  if (diffInHours < 24) {
    return `${diffInHours}시간 전`;
  }

  if (diffInDays < 7) {
    return `${diffInDays}일 전`;
  }

  const year = _time.getFullYear();
  const month = String(_time.getMonth() + 1);
  const day = String(_time.getDate());

  return `${year}.${month}.${day}`;
};
